import { ApolloError, useQuery } from '@apollo/client'
import { MEETINGS_HISTORY_BY_REPLYER } from '../meeting.graphql'
import { MeetingsHistoryByReplyerQuery, MeetingsHistoryByReplyerQueryVariables } from '../../../types'

export default (
  replyerId: string,
  isResigned = false,
): {
  data: MeetingsHistoryByReplyerQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, loading, error } = useQuery<MeetingsHistoryByReplyerQuery, MeetingsHistoryByReplyerQueryVariables>(
    MEETINGS_HISTORY_BY_REPLYER,
    {
      variables: {
        replyerId: replyerId,
        isResigned: isResigned,
      },
      fetchPolicy: 'network-only',
    },
  )

  return { data, loading, error }
}
